export default __webpack_public_path__ + "static/media/hourglass.05dd64cc.png";